<div class="row">
  <div class="col-sm-1">
    <img class="vehicle-info-logo" src="{{imageFullPath}}" height="60px" width="64px" alt="">
  </div>
  <div class="col-sm-11">
    <div class="row vehicle-info-content">
      <span class="vehicle-info-title" translate>dimbo.i18n.header.vehicleInformation</span>
    </div>
    <div class="row " *ngIf="!noDataFound">
      <div class="vehicle-info-description">
        <span>{{vehicleBrand}}</span> <span class="line-separation"></span>
        <span>{{vehicleModel}}</span> <span class="line-separation"></span>
        <span>{{vehicleColor}}</span> <span class="line-separation"></span>

        <span translate>dimbo.i18n.label.vin</span>:&nbsp;
        <span style="font-family:none">{{vehicleVin}}</span> <span class="line-separation"></span>

        <span translate>dimbo.i18n.label.registration </span>:&nbsp;
        <span>{{vehicleRegistrationNo}}</span> <span class="line-separation"></span>

        <span translate>dimbo.i18n.label.firstRegistrationDate </span>:&nbsp;
        <span>{{vehicleRegistrationDate}}</span> <span class="line-separation"></span>

        <span translate>dimbo.i18n.label.currentMileage</span>:&nbsp;
        <span>{{vehicleMileageValue | number:'': vilocale}}</span>
        <span style="margin-left: 2px;">{{vehicleMileageUnit}}</span>


        <span *ngIf="!isReadOnly" class="event-hover" style="color:#1F54A3 ;" (click)="onVehicleInfoEdit()">
          <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
        </span>
        <span *ngIf="isReadOnly" class="event-hover" style="cursor: not-allowed">
          <mat-icon fontSet="material-icons-outlined">edit</mat-icon>
        </span>
      </div>
    </div>
  </div>
</div>